import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface BuyingGuidesProps {
  currentLang: string;
}

export default function BuyingGuides({ currentLang }: BuyingGuidesProps) {
  const { t } = useTranslation('home');
  const navigate = useNavigate();

  const guides = [
    {
      titleKey: 'guides_qc',
      descKey: 'guides_qc_desc',
      slug: 'allchinabuy-qc-guide',
      icon: 'ri-camera-lens-line',
      color: 'bg-accent-500',
    },
    {
      titleKey: 'guides_shipping',
      descKey: 'guides_shipping_desc',
      slug: 'allchinabuy-shipping-comparison',
      icon: 'ri-truck-line',
      color: 'bg-primary-500',
    },
    {
      titleKey: 'guides_warehouse',
      descKey: 'guides_warehouse_desc',
      slug: 'allchinabuy-warehouse-guide',
      icon: 'ri-archive-line',
      color: 'bg-secondary-500',
    },
    {
      titleKey: 'guides_seller',
      descKey: 'guides_seller_desc',
      slug: 'finding-trusted-sellers-allchinabuy',
      icon: 'ri-user-search-line',
      color: 'bg-accent-500',
    },
    {
      titleKey: 'guides_safety',
      descKey: 'guides_safety_desc',
      slug: 'is-allchinabuy-safe',
      icon: 'ri-shield-check-line',
      color: 'bg-primary-500',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-accent-500 text-xs font-semibold uppercase tracking-[0.15em] mb-3 block">
            Guides
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-900">
            {t('guides_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {guides.map((guide) => (
            <div
              key={guide.slug}
              onClick={() => navigate(`/${currentLang}/blog/${guide.slug}/`)}
              className="card-hover group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/40 cursor-pointer text-center"
            >
              <div className={`w-12 h-12 rounded-full ${guide.color} flex items-center justify-center mx-auto mb-4`}>
                <i className={`${guide.icon} text-background-50 text-lg`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {t(guide.titleKey)}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {t(guide.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}